// extracted by mini-css-extract-plugin
var _1 = "count-AC9Hx";
var _2 = "form-PC5i9";
var _3 = "link-BB3eN";
var _4 = "list-hUSLu";
var _5 = "title-fIpeL";
export { _1 as "count", _2 as "form", _3 as "link", _4 as "list", _5 as "title" }
